import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { graphqlFetcher } from "~/api/fetchers";
import * as Types from "~/api/graphql-types";

export type FeaturesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type FeaturesQuery = { __typename?: "Query" } & {
  availableFeatures: { __typename?: "AvailableFeatureQueryPayload" } & {
    features: Array<
      { __typename?: "AvailableFeature" } & Pick<Types.AvailableFeature, "permissionName">
    >;
  };
  editableFeatures: { __typename?: "FeatureQueryPayload" } & {
    features: Array<
      { __typename?: "Feature" } & Pick<
        Types.Feature,
        "id" | "permissionName" | "name" | "description" | "enabled"
      >
    >;
  };
};

export const FeaturesDocument = `
    query features {
  availableFeatures {
    features {
      permissionName
    }
  }
  editableFeatures {
    features {
      id
      permissionName
      name
      description
      enabled
    }
  }
}
    `;

export const useFeaturesQuery = <TData = FeaturesQuery, TError = unknown>(
  variables?: FeaturesQueryVariables,
  options?: Omit<UseQueryOptions<FeaturesQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<FeaturesQuery, TError, TData>["queryKey"];
  }
) => {
  return useQuery<FeaturesQuery, TError, TData>({
    queryKey: variables === undefined ? ["features"] : ["features", variables],
    queryFn: graphqlFetcher<FeaturesQuery, FeaturesQueryVariables>(FeaturesDocument, variables),
    ...options,
  });
};

useFeaturesQuery.getKey = (variables?: FeaturesQueryVariables) =>
  variables === undefined ? ["features"] : ["features", variables];
